import { api } from '@/core/api/request'
import { logger } from '@/core/app/logger'
import {
  type QrRewardAcquireResponse,
  QrRewardAcquireResponseSchema,
  type QrRewardDetailResponse,
  QrRewardDetailResponseSchema,
} from '@/schemas/v2/qr-reward'

const BASE = process.env.NEXT_PUBLIC_API_URL ?? ''

type FetchOptions = { headers?: Record<string, string> }

/** QR特典の詳細/状態を取得する（GET /api/v2/qr-rewards/{id}・認証任意）。 */
export async function fetchQrReward(id: number, options?: FetchOptions): Promise<QrRewardDetailResponse> {
  const url = `${BASE}/api/v2/qr-rewards/${id}`
  logger.info({ fetch_method: 'GET', fetch_url: url, msg: 'fetch 開始' })
  try {
    const data = await api.get<unknown>(url, options)
    return QrRewardDetailResponseSchema.parse(data)
  } catch (e) {
    logger.error({ fetch_method: 'GET', fetch_url: url, msg: `fetch エラー: ${String(e)}` })
    throw e
  }
}

/**
 * QR特典を獲得する（POST /api/v2/qr-rewards/{id}/acquire）。
 * 認証ON特典は認証必須（未認証は 401）。認証OFF特典は serial 必須（単回使用）。
 * 再表示用の httpOnly Cookie はサーバが設定する。
 */
export async function acquireQrReward(
  id: number,
  serial?: string | null,
  options?: FetchOptions,
): Promise<QrRewardAcquireResponse> {
  const query = serial ? `?serial=${encodeURIComponent(serial)}` : ''
  const url = `${BASE}/api/v2/qr-rewards/${id}/acquire${query}`
  logger.info({ fetch_method: 'POST', fetch_url: url, msg: 'fetch 開始' })
  try {
    const data = await api.post<unknown>(url, undefined, options)
    return QrRewardAcquireResponseSchema.parse(data)
  } catch (e) {
    logger.error({ fetch_method: 'POST', fetch_url: url, msg: `fetch エラー: ${String(e)}` })
    throw e
  }
}
